var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInGame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.25a.75.75 0 01.75.75v3.146a2 2 0 11-1.5 0V7a.75.75 0 01.75-.75zm0 5.25a.5.5 0 100 1 .5.5 0 000-1z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 .5a1 1 0 011 1V2c0 .066-.008.13-.02.191a10.102 10.102 0 015.094 2.733c.9.9 1.613 1.958 2.138 3.175A9.734 9.734 0 0122 11.998a9.743 9.743 0 01-.787 3.9 10.102 10.102 0 01-2.138 3.176c-.9.9-1.957 1.613-3.174 2.138a9.734 9.734 0 01-3.899.788 9.743 9.743 0 01-3.9-.787 10.102 10.102 0 01-3.176-2.138 10.1 10.1 0 01-2.138-3.174A9.735 9.735 0 012 12.002c0-1.383.262-2.683.787-3.9a10.102 10.102 0 012.138-3.176 10.099 10.099 0 015.094-2.735A.998.998 0 0110 2v-.5a1 1 0 011-1h2zm-1 3.08c-2.333 0-4.32.819-5.96 2.46C4.398 7.68 3.58 9.666 3.58 12s.819 4.32 2.46 5.96c1.64 1.641 3.627 2.46 5.96 2.46s4.32-.819 5.96-2.46c1.641-1.64 2.46-3.627 2.46-5.96s-.819-4.32-2.46-5.96C16.32 4.398 14.334 3.58 12 3.58z",
    fill: "currentColor"
  })));
}
SvgInGame.displayName = 'InGame';
export default SvgInGame;